import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
	useChat,
	RoomChatWindow,
	RoomMessageListContainer,
	ChatInputContainer,
} from 'features/Chat'

/**
 * Portfolio room chat. Mirrors ProjectChat, minus the `~Name` trigger: we hand
 * ChatContext the final room key up front, which is also the socket room, the
 * Mongo `roomId`, and the message cache key. That avoids the double fetch and
 * dead socket join the trigger causes, and sidesteps a real collision, since
 * a portfolio's assetName is unique only per owner.
 *
 * Portfolios_ShowCN already returns null until the portfolio loads, and the
 * room key needs only the route param, so there is no selector or spinner here.
 */
const PortfolioChat = () => {
	const { id } = useParams()
	const {
		actions: { setCurrentEventId },
	} = useChat()

	useEffect(() => {
		if (id) setCurrentEventId(`portfolio:${id}`)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	if (!id) return null

	return (
		<RoomChatWindow>
			{/* shouldAlwaysDisplay is required: without it an empty room renders no
			    composer and could never receive its first message. */}
			<RoomMessageListContainer />
			<ChatInputContainer shouldAlwaysDisplay={true} />
		</RoomChatWindow>
	)
}

export default PortfolioChat
